import glamorous from 'glamorous';

import { media } from '../../../styles';

const TaraPopoverFooter = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 16,
  animationDelay: '1600ms',

  '& > .LeftButton': {
    marginTop: 16,
  },

  [media('sm')]: {
    flexDirection: 'row-reverse',

    '& > .LeftButton': {
      marginTop: 0,
      marginRight: 16,
    },
  },
}));

export default TaraPopoverFooter;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraPopoverFooter.js